// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"00a34e8eccc261a77944","655":"2b2d73b119edef0c06c9"}[chunkId] + ".js";
};